import {
  VehicleSystemParamsType,
  VehicleSystemType,
} from '@/common/queries/selections/vehicleSystem/vehicleSystem.type';
import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleSystemFunction = ({
  insurance,
  type,
  name,
}: VehicleSystemParamsType): Promise<VehicleSystemType[]> => {
  return fetchApi.get('/selection_item/vehicle/wop_list/', {
    params: { insurance, type, name },
  });
};
export const getInfiniteVehicleSystemFunction = ({
  insurance,
  type,
  name,
}: VehicleSystemParamsType): Promise<
  PaginationResponseType<VehicleSystemType[]>
> => {
  return fetchApi.get('/selection_item/vehicle/list/', {
    params: { insurance, type, name },
  });
};
